import { ReactElement } from 'react';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { useCasinoGamesConfigsValues } from 'newelements/Casino/Games/__partials/providers/CasinoGamesConfigsContext';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import '../__partials/ImageContainer/index.less';
import '../Desktop/index.less';
import '../Mobile/index.less';
import './index.less';
import '../index.less';

export const CasinoGameCardSkeleton = ({
  extraStyle,
  hidePartials
}: {
  extraStyle?: boolean;
  hidePartials?: {
    name?: boolean;
    providerTitle?: boolean;
    favorite?: boolean;
  };
}): ReactElement => {
  const { configs } = useCasinoGamesConfigsValues();

  return (
    <div
      className={cc([
        'x-casinoGameCardWrapper',
        {
          cardSkeleton__position: extraStyle
        }
      ])}
    >
      <div
        className={cc([
          {
            'x-casinoGameCardMobile': isMobile(),
            'x-casinoGameCardDesktop': !isMobile(),
            cardSkeleton__position: extraStyle
          }
        ])}
        style={{
          width: '100%'
        }}
      >
        <div className="x-casinoGameCardImageWrapper x-casinoGameCardImageWrapper__skeleton">
          <Skeleton.Image
            className="x-casinoGameCardImageSkeleton"
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              right: 0,
              bottom: 0,
              width: '100%',
              height: '100%'
            }}
          />
        </div>
      </div>
      {configs.gameTitle && (
        <div
          className={cc([
            'x-casinoGameCardTitle',
            {
              'x-casinoGameCardTitle--mobile': isMobile(),
              'x-casinoGameCardTitle--desktop': !isMobile(),
              cardSkeleton__position: extraStyle
            }
          ])}
        >
          {!hidePartials?.name && (
            <div className="x-casinoGameCardTitle__gameName">
              <Skeleton
                active
                paragraph={false}
                title={{
                  style: {
                    height: '12px',
                    width: '140px',
                    margin: '2px 0'
                  }
                }}
              />
            </div>
          )}
          {!hidePartials?.providerTitle && (
            <div className="x-casinoGameCardTitle__providerName">
              <Skeleton
                active
                paragraph={false}
                title={{
                  style: {
                    height: '12px',
                    width: '100px',
                    margin: '2px 0'
                  }
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
